import { render, staticRenderFns } from "./commonPanel.vue?vue&type=template&id=577ca52b&"
import script from "./commonPanel.vue?vue&type=script&lang=js&"
export * from "./commonPanel.vue?vue&type=script&lang=js&"
import style0 from "./commonPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports